module.exports = __webpack_public_path__ + "fonts/59ZRklaO5bWGqF5A9baEEYX0hVgzZQUfRDuZrPvH3D8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/Sans/59ZRklaO5bWGqF5A9baEEYX0hVgzZQUfRDuZrPvH3D8.woff2
// module id = 382
// module chunks = 0